<template>
  <el-input
    v-if="!useReadOnly"
    ref="cargoInput"
    :value="value"
    :maxlength="maxlength"
    :type="type"
    :rows="rows"
    :disabled="disabled"
    :placeholder="placeholder||undefined"
    :filter-chars="filterChars"
    @blur="$emit('blur',$event)"
    @focus="$emit('focus',$event)"
    @input="onInput"
  />
  <el-input
    v-else
    ref="cargoInput"
    :value="value"
    :maxlength="maxlength"
    :type="type"
    :rows="rows"
    :readonly="disabled"
    :placeholder="placeholder||undefined"
    :filter-chars="filterChars"
    :class="disabled ? 'is-disabled' : ''"
    @blur="$emit('blur',$event)"
    @focus="$emit('focus',$event)"
    @input="onInput"
  />
</template>

<script>
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'CargoInput',
  model: { prop: 'value', event: 'change' },
  props: {
    value: { type: [String, Number], required: true },
    maxlength: { type: Number, default: -1 },
    autoUppercase: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    rows: { type: Number, default: 2 },
    inputConvert: { type: Function, default: null },
    colorClass: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    autoHalfWord: { type: Boolean, default: false },
    filterChars: { type: Boolean, default: true },
    trim: { type: Boolean, default: false },
    useReadOnly: { type: Boolean, default: false }
  },
  data() {
    return {}
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('change', this.formatValue(newVal))
      }
    }
  },
  methods: {
    onInput(val) {
      const value = this.formatValue(val)
      this.$emit('input', value)
      this.$emit('change', value)
    },
    formatValue(val) {
      if (this.autoUppercase && typeof val === 'string') {
        val = val.toUpperCase()
      }
      if (typeof this.inputConvert === 'function') {
        val = this.inputConvert(val)
      }
      if (this.autoHalfWord) {
        val = StrUtils.toHalfword(val)
      }
      if (this.trim) {
        val = val.trim().replace(/^\n+|\n+$/g, '')
      }
      return val
    }
  }
}
</script>

<style>
</style>
